
import { Vue, Component } from "vue-property-decorator";

@Component({ name: "icon-location-outline" })
export default class IconLocationOutline extends Vue {}
